import React, { Component } from "react";
import { callPlayer, getSDK } from "../utils.js";
const SDK_URL = "https://fast.wistia.com/assets/external/E-v1.js";
const SDK_GLOBAL = "Wistia";
const MATCH_URL = /(?:wistia\.com|wi\.st)\/(?:medias|embed)\/(.*)$/;
class Wistia extends Component {
  constructor() {
    super(...arguments);
    this.callPlayer = callPlayer;
    // Proxy methods to prevent listener leaks
    this.onPlay = (...args) => this.props.onPlay(...args);
    this.onPause = (...args) => this.props.onPause(...args);
    this.onSeek = (...args) => this.props.onSeek(...args);
    this.onEnded = (...args) => this.props.onEnded(...args);
    this.mute = () => {
      this.callPlayer("mute");
    };
    this.unmute = () => {
      this.callPlayer("unmute");
    };
  }
  getID(url) {
    return url && url.match(MATCH_URL)[1];
  }
  load(url) {
    const { playing, muted, controls, onReady, config, onError } = this.props;
    getSDK(SDK_URL, SDK_GLOBAL).then(() => {
      window._wq = window._wq || [];
      window._wq.push({
        id: this.getID(url),
        options: {
          autoPlay: playing,
          silentAutoPlay: "allow",
          muted,
          controlsVisibleOnLoad: controls,
          ...config.wistia.options
        },
        onReady: (player) => {
          this.player = player;
          this.unbind();
          this.player.bind("play", this.onPlay);
          this.player.bind("pause", this.onPause);
          this.player.bind("seek", this.onSeek);
          this.player.bind("end", this.onEnded);
          onReady();
        }
      });
    }, onError);
  }
  unbind() {
    this.player.unbind("play", this.onPlay);
    this.player.unbind("pause", this.onPause);
    this.player.unbind("seek", this.onSeek);
    this.player.unbind("end", this.onEnded);
  }
  play() {
    this.callPlayer("play");
  }
  pause() {
    this.callPlayer("pause");
  }
  stop() {
    this.unbind();
    this.callPlayer("remove");
  }
  seekTo(seconds) {
    this.callPlayer("time", seconds);
  }
  setVolume(fraction) {
    this.callPlayer("volume", fraction);
  }
  setPlaybackRate(rate) {
    this.callPlayer("playbackRate", rate);
  }
  getDuration() {
    return this.callPlayer("duration");
  }
  getCurrentTime() {
    return this.callPlayer("time");
  }
  getSecondsLoaded() {
    return null;
  }
  render() {
    const id = this.getID(this.props.url);
    const className = `wistia_embed wistia_async_${id}`;
    const style = {
      width: "100%",
      height: "100%"
    };
    return /* @__PURE__ */ React.createElement("div", { key: id, className, style });
  }
}
Wistia.displayName = "Wistia";
Wistia.canPlay = (url) => MATCH_URL.test(url);
Wistia.loopOnEnded = true;
export {
  Wistia
};
//# sourceMappingURL=Wistia.js.map
